import { render, staticRenderFns } from "./BankingRequestAnAccount.vue?vue&type=template&id=37a60ef8&"
import script from "./BankingRequestAnAccount.vue?vue&type=script&lang=ts&"
export * from "./BankingRequestAnAccount.vue?vue&type=script&lang=ts&"
import style0 from "./BankingRequestAnAccount.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports